import { createSlice } from "@reduxjs/toolkit";

const initialNoticeGroup = {
  name: "",
  definition: ""
};

const initialNoticeGroupsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  authorities: null,
  noticeGroup: initialNoticeGroup
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const noticeGroupSlice = createSlice({
  name: "noticeGroups",
  initialState: initialNoticeGroupsState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getNoticeGroups
    noticeGroupsFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getNoticeGroup
    noticeGroupFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.noticeGroup = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanNoticeGroupsState
    noticeGroupsStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
      state.noticeGroup = initialNoticeGroup;
    }
  }
});